import script from "./CommentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentSection.vue?vue&type=script&setup=true&lang=js"

import "./CommentSection.vue?vue&type=style&index=0&id=0e11e88e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e11e88e"]])

export default __exports__